
import { useEffect, useRef, useState } from "react";
import { Plus, Search } from "react-feather";
import { FaSearch } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { createIssue, updateIssue, createIssueStatus } from "../../api/issueApi";
import { toast } from "react-toastify";
import {IssueIcon} from "../../components/sidebar/icon/IssueIcon";
import {getBulkDropdownData,} from "../../api/keyvalue";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Tab from "../../components/Tab";
import IssueForm from "../../components/fleet/IssueForm";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SideDrawer from "../../components/input/SideDrawer";
import { getIssuesByIds } from "../../api/issueApi";
import {ActiveCellStyle, IssueStatusCellStyle} from "../../components/renderer/StyleRenderer";
import { PriorityCellStyle} from "../../components/renderer/StyleRenderer";
import {  FORMS, MODULES } from "../../const";
import { searchIssues } from "../../api/issueApi";
import { getTags } from "../../api/tagApi";
import { getIssueById } from "../../api/issueApi";
import Modal from "../../components/Modal";
import IssueStatusManagement from "../../components/fleet/IssueStatusManagement";

const IssueManagement = () => {
    const location = useLocation();
    const [selectedRows, setSelectedRows] = useState([]);
    const { pathname } = location;
    const issueRef = useRef();
    const [tab, setTab] = useState(1);
    const user = useSelector((state) => state.user);
    const gridRef = useRef(null);
    const [searchClicked, setSearchClicked] = useState(false);
    const [isSearchResultsPending, setIsSearchResultsPending] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [isDm, setIsDm] = useState(true);
    const [resetSearchFields, setResetSearchFields] = useState(false);
    const [statusOpt, setStatusOpt] = useState([]);
    const [vehicleNumber, setVehicleNumber] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [selectedIssue, setSelectedIssue] = useState(null);
    const [status, setStatus] = useState("");
    const [code, setCode] = useState("");
    const [template, setTemplate] = useState("");
    const [favMode, setFavMode] = useState(false);
    const [priorityOptions, setPriorityOptions] = useState([]);
    const [priority, setPriority] = useState("");
    const [tagOptions, setTagOptions] = useState([]);
    const [activeAccordion1, setActiveAccordion1] = useState(true);
    const [label, setLabel] = useState("");
    const [currentIssueId, setCurrentIssueId] = useState(null);
    const [currentIssueCode, setCurrentIssueCode] = useState(null);
    const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
    const [popUpKey, setPopUpKey] = useState(1);
    const [activeOptions, setActiveOptions] = useState([]);
    const [activeFilter, setActiveFilter] = useState("");
    const handleAccordionClick1 = () => {
        setActiveAccordion1(!activeAccordion1);
    };
    const modalRef = useRef();
    const handleIssueDownload = async () => {
        try {
            const ids = selectedRows.map(r => r.fliId);
            if (!ids.length) return;
            const priorityMap = {};
            priorityOptions.forEach(p => {
                priorityMap[Number(p.value)] = p.text;
            });    
            const statusMap = {};
            statusOpt.forEach(s => {
                statusMap[Number(s.value)] = s.text;
            });
            const response = await getIssuesByIds(ids);   
            if (!response || !response.length) return;
            const headerMap = {
                code: "Issue Code",
                topic: "Topic",
                vehicleNumber: "Vehicle",
                description: "Description",      
                labels: "Labels",
                primaryMeter: "Primary Meter",
                primaryMeterDue: "Meter Due",        
                priority: "Priority",
                status: "Status",
                active: "Active",         
                reportedTime: "Reported Time",
                dueDate: "Due Date",   
                createdBy: "Created By",
                createdDate: "Created Date",
                lastModifiedBy: "Last Modified By",
                lastModifiedDate: "Last Modified Date"
            };
    
            const keys = Object.keys(headerMap);
            const csvRows = [];
            csvRows.push(keys.map(k => headerMap[k]).join(","));
            response.forEach(row => {
                const values = keys.map(k => {
                    let val = row[k] ?? ""; 
                    if (k === "priority") {
                        val = priorityMap[val] || val;
                    }  
                    if (k === "status") {
                        val = statusMap[val] || val;
                    }  
                    if (k === "reportedTime" || k === "createdDate" || k === "dueDate" || k === "lastModifiedDate") {
                        val = val ? new Date(val).toLocaleString() : "";
                    }  
                    val = val.toString().replace(/"/g, '""');
                    return `"${val}"`;
                });
            
                csvRows.push(values.join(","));
            });
    
            // download
            const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Issue_Details.csv";
            a.click();
            URL.revokeObjectURL(url);   
        } catch (err) {
            console.error(err);
        }
    };
    useEffect(() => {
        if (window.location.pathname.includes("document-management")) {
            setIsDm(true);
        } else {
            setIsDm(false);
        }
        handleReset();
    }, [pathname]);

    useEffect(() => {
        (async () => {
            const tags = await getTags();

            const formatted = tags.map(tag => ({
                key: tag.ftaId,
                value: tag.ftaId,
                text: tag.ftaLabel
            }));
            setTagOptions(formatted);
        })();
    }, []);

    useEffect(() => {
        setFromDate("");
        setToDate("");
    }, []);

    useEffect(() => {
        (async () => {
            if (!favMode) {
                setIsLoading(true);
                const {
                    priority,
                    service_status,
                    active
                } = await getBulkDropdownData([
                    { key: "service_status" },
                    { key: "priority" },
                    { key: "active" }

                ]);
                setStatusOpt(service_status);
                setPriorityOptions(priority);
                setIsLoading(false);
                setActiveOptions(active);
            }
        })();
    }, [favMode]);

    const handleSearchIssues = async () => {
        setIsSearchResultsPending(true);
        try {
            const payload = {
                fliCode: code || null,
                vehicleNumber: vehicleNumber || null,
                fliPriority: priority ? Number(priority) : null,
                fliStatus: status ? Number(status) : null,
                fromDate: fromDate || null,
                toDate: toDate || null,
                labelId: label || null,
                fliActive: activeFilter !== "" ? Number(activeFilter) : null,
            };

            const response = await searchIssues(payload);
            const statusMap = {};
            statusOpt.forEach((s) => {
                statusMap[Number(s.value)] = s.text;
            });
                            const priorityMap = {};
                priorityOptions.forEach((p) => {
                priorityMap[Number(p.value)] = p.text;
                });
            const formatted = response.map((item) => ({
                ...item,
                fliStatusId: item.fliStatus,
                fliStatus: statusMap[item.fliStatus] || "N/A",
                fliPriorityId: item.fliPriority,
                fliPriority: priorityMap[item.fliPriority] || "N/A",
                fliActive: item.fliActive === 1 ? "Active" : "Deleted",
                reportedTime: item.fliReportedTime
                    ? new Date(item.fliReportedTime).toISOString().split("T")[0]
                    : "N/A",
                dueDate: item.fliDueDate
                    ? new Date(item.fliDueDate).toISOString().split("T")[0]
                    : "N/A",
            }));
      
            setSearchResults(formatted);
            setSearchClicked(true);
        } catch (e) {
            console.error(e);
        }
        setIsSearchResultsPending(false);
    };

    const handleReset = () => {
        setVehicleNumber("");
        setCode("");
        setFromDate("");
        setToDate("");
        setStatus("");
        setPriority("");
        setLabel("");
        setSearchClicked(false);
        setSearchResults([]);
        setActiveFilter("");
        setResetSearchFields((p) => !p);
    };

    const handleDrawerClose = () => {
        setEditMode(false);
        setIsDrawerOpen(false);
    };

    const handleDrawerOpen = () => {
        setEditMode(false);
        setSelectedIssue(null)
        setIsDrawerOpen(true);
        ;
    };

    console.log("favMode", favMode);
    const getActionMenuOptions = () => [
        {
            key: 1,
            text: "Download Details",
            value: 1,
        }
    ];
    
    const actionsMenuChange = (data) => {
        if (data.value === 1) {
            handleIssueDownload();
        }
    };

    return (
        <div>
            <div
    className="ui tabular attached"
    style={{
        display: "flex",
        justifyContent: "space-between",
    }}
>
    <div className="ui tabular menu top attached">
        <Tab
            Icon={FaSearch}
            onClick={() => {
                setTab(1);
            }}
            active={tab === 1}
            label="Search"
        />
    </div>
                    <div style={{ display: "flex", gap: "10px" }}>
                        
                        <Button
                            label={"New"}
                            Icon={Plus}
                            template="drawerOpen"
                            onClick={handleDrawerOpen}
                            authenticated={false}
                            form={FORMS.FLEET_ISSUE.ISSUE_MANAGEMENT.form}
                            module={MODULES.Fleet}
                            editMode={false}
                            disabled={false}
                        />
                    </div>
                </div>

            <div
                className="ui bottom attached active tab segment"
                style={{ display: tab === 1 ? "block" : "none", width: "100%" }}
            >
                <div
                    class="ui styled accordion"
                    style={{ width: "100%", marginBottom: "10px" }}
                >
                    <div
                        className={`title ${activeAccordion1 ? "active" : ""}`}
                        onClick={() => handleAccordionClick1(!activeAccordion1)}
                    >
                        <div>
                            Click here to search
                            <Search size={14} style={{ marginLeft: "10px" }} />
                            <i class="dropdown icon"></i>
                        </div>
                    </div>
                    <div className={`content ${activeAccordion1 ? "active" : ""}`}>
                        {isLoading ? (
                            <LoadingSpinner />
                        ) : (
                            <form className="ui form">
                                <h4 className="ui dividing header">Information</h4>


                                <div className="three fields">

                                    <Input
                                        label="Issue Number"
                                        type="text"
                                        name="code"
                                        placeholder={"Example - FLI-01"}
                                        value={code}
                                        onChange={(e) => {
                                            setCode(e.target.value);
                                        }}
                                    />
                                    <Input
                                        label="Vehicle Number"
                                        type="text"
                                        name="vehicleNumber"
                                        value={vehicleNumber}
                                        onChange={(e) => setVehicleNumber(e.target.value)}
                                    />

                                    <Input
                                        label="From Date"
                                        type="date"
                                        name="fromDate"
                                        value={fromDate}
                                        onChange={(e) => {
                                            setFromDate(e.target.value);
                                        }}
                                    />

                                    <Input
                                        label="To Date"
                                        type="date"
                                        name="toDate"
                                        value={toDate}
                                        onChange={(e) => {
                                            setToDate(e.target.value);
                                        }}
                                    />
                                </div>
                                <div className="four fields">

                                    <Dropdown
                                        clearable
                                        search
                                        options={priorityOptions}
                                        placeholder="Priority Level"
                                        label="Priority Level"
                                        value={priority}
                                        onChange={(e, data) => setPriority(data.value)}
                                    />

                                    <Dropdown
                                        clearable
                                        options={statusOpt}
                                        placeholder="Status"
                                        label="Status"
                                        value={status}
                                        onChange={(e, data) => setStatus(data.value)}
                                    />

                                    <Dropdown
                                        clearable
                                        search
                                        options={tagOptions}
                                        placeholder="Label"
                                        label="Label"
                                        value={label}
                                        onChange={(e, d) => setLabel(d.value)}
                                    />
                                    <Dropdown
                                        clearable
                                        options={activeOptions}
                                        placeholder="Action"
                                        label="Action"
                                        value={activeFilter}
                                        onChange={(e, d) => setActiveFilter(d.value)}
                                    />

                                </div>
                                <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-end",
                                    }}
                                >
                                    <div className="field" style={{ width: "100%" }}>
                                        <Button
                                            template="search"
                                            onClick={handleSearchIssues}
                                            disabled={favMode ? true : false}
                                        />
                                        <Button
                                            template="searchReset"
                                            onClick={handleReset}
                                            disabled={favMode ? true : false}
                                        />
                                    </div>
                                </div>
                            </form>

                        )}
                    </div>
                </div>

                {searchClicked && (
    <>
        {isSearchResultsPending ? (
            <LoadingSpinner />
        ) : (
            <Grid
                ref={gridRef}
                heading=" "
                multiRowSelection={true}
                onSelectionChanged={(e) => {
                    setSelectedRows(e.api.getSelectedRows());
                }}
                showActionMenu={selectedRows.length > 0}
                actionMenuOptions={getActionMenuOptions()}
                handleActionMenuChange={actionsMenuChange}
                isLoading={isSearchResultsPending}
                autoHeight={true}
                searchable={true}
                content={searchResults}
                config={[
                    {
                        headerName: "",
                        checkboxSelection: true,
                        headerCheckboxSelection: true,
                        width: 40,
                        maxWidth: 40,
                        minWidth: 40,
                        resizable: false,
                        pinned: "left"
                    },
                    {
                        headerName: "Vehicle No",
                        field: "vehicleNumber",
                        width: 130,
                    },
                    {
                        headerName: "Issue No",
                        field: "fliCode",
                        width: 150,
                    },
                    {
                        headerName: "Topic",
                        field: "fliTopic",
                        width: 200,
                    },
                    {
                        headerName: "Status",
                        field: "fliStatus",
                        width: 150,
                        cellRenderer: (params) => (
                            <div
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setCurrentIssueId(params.data?.fliId);
                                    setCurrentIssueCode(params.data?.fliCode);
                                    setPopUpKey(prev => prev + 1);
                                    modalRef.current?.showModal();
                                }}
                            >
                                <IssueStatusCellStyle {...params} />
                            </div>
                        ),
                    },
                    {
                        headerName: "Priority",
                        field: "fliPriority",
                        width: 120,
                        cellRenderer: PriorityCellStyle,
                        cellStyle: { padding: 0 }
                      },
                    {
                        headerName: "Report Date",
                        field: "reportedTime",
                        width: 150,
                    },
                    {
                        headerName: "Assigned By",
                        field: "createdBy",
                        width: 150,
                    },
                    {
                        headerName: "Action",
                        field: "fliActive",
                        width: 120,
                        cellRenderer: ActiveCellStyle,
                    },
                ]}

                onCellDoubleClicked={async (props) => {
                    try {
                        const id = props.data.fliId;
                        const fullData = await getIssueById(id);
                        setSelectedIssue(fullData);
                        setEditMode(true);
                        setIsDrawerOpen(true);
                    } catch (e) {
                        console.error(e);
                    }
                }}
            />
        )}
    </>
)}
</div>

            <SideDrawer
                open={isDrawerOpen}
                handleDrawerClose={handleDrawerClose}
                head={
                    !editMode ? (""
                    ) : (
                        <h3>Update Issue {selectedIssue?.fliCode}</h3>
                    )
                }
                body={
                    <form
                        className="drawer-content"
                        onSubmit={async (e) => {
                            e.preventDefault();
                            const errors = issueRef.current.validateForm();

                            if (Object.keys(errors).length > 0) {
                                console.log("Validation Errors:", errors);
                                issueRef.current.setErrors(errors);
                                return; 
                            }
                            const data = issueRef.current.getData();
                            console.log("FINAL LABEL FROM FORM:", data.label); 
                            try {
                                const payload = {
                                    fliId: Number(data.id), 
                                    topic: data.topic,
                                    vehicle: data.vehicleId,
                                    description: data.description,
                                    labels: data.label || [],
                                    primaryMeter: data.primaryMeter
                                        ? Number(data.primaryMeter)
                                        : null,
                                    priority: data.priority,
                                    reportedTime: data.reportDateTime
                                        ? new Date(data.reportDateTime)
                                        : null,
                                    dueDate: data.dueDate
                                        ? new Date(data.dueDate)
                                        : null,
                                    status: data.status,
                                    active: data.fliActive,

                                    primaryMeterDue: data.primaryMeterDue
                                        ? Number(data.primaryMeterDue)
                                        : null,
                                    user: user.username,
                                };
                                if (editMode) {
                                    await updateIssue(payload);
                                  
                                    toast.success("Issue updated successfully", { containerId: "Main" });
                                } else {
                                    await createIssue(payload);
                                    toast.success("Issue created successfully", { containerId: "Main" });
                                }              
                                await handleSearchIssues();
                                setIsDrawerOpen(false);
                                setEditMode(false);        
                                setSelectedIssue(null);

                            } catch (error) {                              
                                toast.error("Failed to save issue", { containerId: "Main" });
                            }
                        }}
                    >
                        <div style={{ width: "60vw", boxShadow: "none" }}>                         
                            <div className="ui top attached tabular menu">
                                <Tab
                                    Icon={IssueIcon}
                                    active={true}
                                    label="Issue"
                                    authenticated={false}
                                />
                            </div>
                            <div className="ui bottom attached active tab segment">
                                <IssueForm
                                    ref={issueRef}
                                    editMode={editMode}
                                    errors={{}} 
                                    dropdown={{ priorityOptions, statusOptions: statusOpt,activeOptions }}
                                    currentValues={editMode ? selectedIssue : null}
                                />
                            </div>

                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                }}
                            >
                                <Button
                                    type="submit"
                                    template="create"
                                    create={!editMode}
                                    form={FORMS.FLEET_ISSUE.ISSUE_MANAGEMENT.form}
                                    module={MODULES.Master}
                                    authenticated={false}
                                    editMode={editMode}
                                    disabled={editMode && selectedIssue?.fliStatus !== 1 && selectedIssue?.fliStatus !== 5}
                                />
                            </div>
                        </div>
                    </form>
                }
                style={{ width: "60vw" }}
/>
            <Modal
                ref={modalRef}
                closeButton={true}
                minWidth="1000px"
            >
                <IssueStatusManagement
                    key={popUpKey}
                    issueId={currentIssueId}
                    issueCode={currentIssueCode}
                    statusOptions={statusOpt}
                    close={() => {
                        modalRef.current?.close();
                    }}
                />
            </Modal>

        </div>
    );
};

export default IssueManagement;

